import noop from 'lodash';
import { ReactElement, useMemo } from 'react';

import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';
import {
   Visit,
   VisitContinuouslyUsedMedicine,
   VisitContinuouslyUsedMedicineQuery,
} from '@dreryk/egabinet-visit-frontend-api';

import { UseCqrsQueryResult, useCqrsSearch } from '@dreryk/command-query-react-common';
import { TableColumnConfiguration, ValueRendererProps } from '@dreryk/react-components';

import { VisitDiagnoses } from '~libs.shared.visit';

import { visitPrescriptionTranslationKeys } from '../../../translations';

import { VisitContinuouslyUsedMedicineTableRow } from './VisitContinuouslyUsedMedicineTableRow/VisitContinuouslyUsedMedicineTableRow';

export const useVisitContinuouslyUsedMedicineQuery = (
   visitId: Visit['id']
): UseCqrsQueryResult<VisitContinuouslyUsedMedicine[]> => {
   return useCqrsSearch<VisitContinuouslyUsedMedicine>(() => {
      const query = new VisitContinuouslyUsedMedicineQuery();
      query.visitId = visitId;
      return query;
   });
};

// eslint-disable-next-line max-lines-per-function
export const useVisitContinuouslyUsedMedicineTableColumns = (
   visitId: Visit['id'],
   isReadonly: boolean | undefined,
   patientId: PatientSimple['id'],
   visitDiagnoses: VisitDiagnoses
): TableColumnConfiguration<VisitContinuouslyUsedMedicine>[] => {
   return useMemo(
      () => [
         {
            name: 'continuouslyUsedMedicine',
            accessor: noop,
            label: visitPrescriptionTranslationKeys.continuouslyUsedMedicines,
            width: '100%',

            renderer: (props: ValueRendererProps<VisitContinuouslyUsedMedicine, any>): ReactElement => {
               return (
                  <VisitContinuouslyUsedMedicineTableRow
                     medicineId={props.bean.patientContinuouslyUsedMedicine.medicineId}
                     prescriptionForContinuouslyUsedMedicinesStatus={
                        props.bean.prescriptionForContinuouslyUsedMedicinesStatus
                     }
                     patientId={patientId}
                     visitId={visitId}
                     patientContinuouslyUsedMedicineId={props.bean.patientContinuouslyUsedMedicine.id}
                     isReadonly={isReadonly}
                     medicineSimple={props.bean.medicineSimple}
                     visitDiagnoses={visitDiagnoses}
                  />
               );
            },
            sortingDisabled: true,
         },
      ],
      [isReadonly, patientId, visitId, visitDiagnoses]
   );
};
